import React, { useEffect, useState } from "react";
import ExpandCollapseButton from "./expandCollapseButton";
import BackToPoolButton from "./backToPoolButton";
import TakeOverButton from "./takeOverButton";
import ReviewEntryButton from "./reviewEntry";
import FileEntryButton from "./fileEntry";
import PreviewPDFButton from "./previewPDFButton";
import RefreshTariffButton from "./refreshTariffButton";
import DownloadCDSDocument from "./downloadCDSdocumentButton";
import StartJobButton from "./startJobButton";
import UpdateEntry from "./updateEntry";
import UnHoldShipmentButton from "./unHoldShipmentButton";
import HoldShipmentButton from "./holdShipmentButton";
import FileUpload from '../../components/GB_App/formSections/fileUpload'
import CDSModal from "./cdsModal";
import { Button } from "semantic-ui-react";
import { getDeclarationStatusApi } from "../../commonApis/getGBForm";
import { showToast } from "../../components/commonComponents/showToast";
//import {resetServerErrors} from "../../../NCTS/store/action/serverErrorAction"; 
import { useDispatch, useSelector } from "react-redux";
import { get } from "lodash";
import { generatePDF } from "../../commonApis";
import GenerateButton from "./generateButton";
import { getJobWheels } from "../../components/util";
import configuration from "../../config/index";
import SendToBilling from "./sendToBillingButton";

function CDSButtonMapper(props) {
  let shipmentId = props.shipId
  let mrn = get(props, 'currentJobData.mrn', '')

  const ucn = useSelector((state) => state.Shipment.ucn);
  const ErrorWarningsList = useSelector((state) => state.ErrorValidationReducer?.headerTab) || []
  const isUcnErr = ErrorWarningsList?.some(itm => (itm?.fieldName === 'ucn' && itm?.msg === 'UCN is mandatory')) || false
  // console.log({isUcnErr,modeOfTransport:props.currentJobData?.modeOfTransport, ErrorWarningsList})
  const locationOfGoods = useSelector((state) => state.Shipment.transportation.locationOfGoods);
  const declarationType=useSelector((state) => state.Shipment.declarationType)
  const containers = useSelector((state) => state.containerReducer);
  const modeOfTransport = props.currentJobData?.modeOfTransport;
  const serviceType = props?.serviceType;
  
  const alertMessageOnReview = () => {
    let msg = [];
    if (serviceType === 'IMPORT' && modeOfTransport === 'OCEAN' && isUcnErr) {
      msg.push(<div>
        This port location code is for inventory port. No UCN has been entered into DE 2/1.
        <p style={{ marginTop: '10px' }}>Do you wish to proceed?</p>
      </div>);
    }
    if (serviceType === 'IMPORT' && modeOfTransport === 'TRUCK' && isUcnErr && containers?.containerList?.length) {
      msg.push(<div>
        Mode of Transport is Truck and Container Number has been added. Have you checked the inventory?
        <p style={{ marginTop: '10px' }}>DO you wish to proceed?</p>
      </div>);
    }
    if (serviceType === 'IMPORT' && modeOfTransport === 'TRUCK' && declarationType === 'A' && locationOfGoods.endsWith('GVM')) {
      msg.push(<div>
        This is a GVMS Port location and the Entry has been prepped as arrived.
        <p style={{ marginTop: '10px' }}>Do you wish to proceed?</p>
      </div>);
    }
    return msg;
  }

  useEffect(() => {
    setTimeout(() => {
      buildButtons()
    }, 5000);

    return () => {

    }
  }, [JSON.stringify(props.currentJobData), props.shipId])

  const [reviewedSuccessfully, setReviewSuccessfully] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [cdsLabel, setCdsLabel] = useState("");
  const [cdsFormType, setCdsFormType] = useState("");

  useEffect(() => {
    //dispatch(resetServerErrors());
    setReviewSuccessfully(false)
  }, [props.shipId])

  const setReviewedSuccess = () => {
    setReviewSuccessfully(true)
  }

  const decStatusAction = async () => {
    let response = await getDeclarationStatusApi(shipmentId)
    if (response.data.eventMessage.code == 200) {
      showToast("Declaration Message Generated Successfully")
    }
  }

  const buildButtons = () => {
    let jobWheels = getJobWheels(props.currentJobData);
    const EntryState = jobWheels["ES_ENTRY_JOB_WHEEL"]?.value?.state || ""
    const ESCustomState = jobWheels["GB_CUSTOM_JOB_WHEEL"]?.value?.state || ""
    const bhHouse = jobWheels["SHIPMENT_BROKER_HOUSE_PROCESS"]?.value?.state || "";
    const is_BH_In_Process = bhHouse === "STATE_BH_BROKER_IN_PROCESS";
    const isCustomNone = ['STATE_CDS_NONE', 'STATE_CUSTOMS_NONE'].includes(ESCustomState);
    console.log("ESCustomState:", ESCustomState)
    const isEntryEditable = EntryState.includes('IN_PROCESS') || EntryState.includes('READY');
    const isEntryInProcess = EntryState.includes('STATE_ENTRY_IN_PROCESS');
    const isEntryFileReady = EntryState.includes('READY');
    const isEntryReady = EntryState.includes('STATE_ENTRY_READY');
    const isEntryFiled = EntryState === 'STATE_ENTRY_FILED';
    const isEntryOnHold = EntryState === 'STATE_ENTRY_ON_HOLD';
    const isEntryRejected = EntryState === 'STATE_ENTRY_REJECTED';
    const isEntryAccepted = EntryState === 'STATE_ENTRY_ACCEPTED';
    const isEntryCleared = EntryState === 'STATE_ENTRY_CLEARED';
    const isEntryAmendInProcess = EntryState.includes('STATE_ENTRY_AMEND_IN_PROCESS');
    const isEntryAmendFileReady = EntryState.includes('STATE_ENTRY_AMEND_READY');
    const isEntryAmendFiled = EntryState === 'STATE_ENTRY_AMEND_FILED';
    const isCancelledFiled = EntryState === 'STATE_ENTRY_CANCELLED_FILED';
    const isCancelAccepted = EntryState === 'STATE_ENTRY_CANCELLED';
    const isCancelledFailed = EntryState === 'STATE_ENTRY_CANCELLED_FAILED'
    const isEntryAmendFailed = EntryState === 'STATE_ENTRY_AMEND_FAILED';
    const isEntryAmendRejected = EntryState === 'STATE_ENTRY_AMEND_REJECTED';
    const isEntryAmendAccepted = EntryState === 'STATE_ENTRY_AMEND_ACCEPTED';
    const underAmendProcess = EntryState.includes("AMEND")
    const userGuid = get(props, "kxUser.userBasicInfo.userGuid");
    const brokerGuid = get(props, "currentJobData.brokerGuid");
    let formType = EntryState.includes("AMEND") ? 'CDS_AMEND' : 'CDS_WRITE';

    let listOfButtons = []

         if(props.showSendToBillingButton){
        listOfButtons.push(
        <SendToBilling {...props} />
      )};
      

    if (((props?.serviceType === 'IMPORT' && ['STATE_DMSACC', 'STATE_DMSRCV', 'STATE_DMSTAX'].includes(ESCustomState)) ||
      (isEntryCleared && ESCustomState === "STATE_DMSCLE"))) {
      listOfButtons.push(<DownloadCDSDocument {...props} />)
    }
    if (isEntryAccepted || isCancelledFiled || isCancelledFailed || underAmendProcess || (isEntryCleared && props?.serviceType === 'EXPORT') || ESCustomState === "STATE_DMSEOG") {
      listOfButtons.push(
        <FileUpload />
      )
    }
    if ((bhHouse === 'STATE_BH_ASSIGNED' || bhHouse === 'STATE_BH_BROKER_ASSIGNED')) {
      if (isEntryOnHold && userGuid === brokerGuid) {
        listOfButtons.push(
          <UnHoldShipmentButton {...props} />
        );
        return listOfButtons;
      }
      else if (isEntryOnHold && userGuid !== brokerGuid) {
        listOfButtons.push(
          <TakeOverButton
            {...props}
            currentEntryState={EntryState}
            ESCustomState={ESCustomState} />);
        return listOfButtons;
      }
      listOfButtons.push(
        <StartJobButton
          {...props}
          EntryState={EntryState}
          ESCustomState={ESCustomState}
          formType={formType}
        />
      );
      return listOfButtons;
    }
    if (is_BH_In_Process) {
      if (userGuid !== brokerGuid && (isEntryEditable || isEntryOnHold)) {
        listOfButtons.push(
          <TakeOverButton
            {...props}
            currentEntryState={EntryState}
            ESCustomState={ESCustomState} />);
        return listOfButtons;
      }
      if ((isEntryInProcess || isEntryFileReady) && userGuid === brokerGuid) {
        listOfButtons.push(
          <BackToPoolButton {...props} />
        );
      }
      if (isEntryOnHold && userGuid === brokerGuid) {
        listOfButtons.push(
          <UnHoldShipmentButton {...props} />
        );
        return listOfButtons;
      }
      if (!isEntryEditable && !isEntryRejected && !isEntryAmendRejected && mrn) {
        listOfButtons.push(<GenerateButton
          {...props}
          customState={ESCustomState}
          mrn={mrn}
        />)
      }
      if (isEntryFiled || isEntryAmendFiled) {
        listOfButtons.push(
          <Button
            id='view-xml-sent'
            size="mini"
            key="XMLSENT"
            disabled={false}
            className="sv todo-button secondaryBtn"
            onClick={() => {
              window.open(`broker-panel/xml-sent/gb/${props.shipId}`, '_blank')
            }}
          >
            VIEW XML SENT
          </Button>)
      }
      if (isEntryEditable) {
        if ((isEntryReady || isEntryInProcess) && !reviewedSuccessfully && userGuid === brokerGuid) {
          listOfButtons.push(
            <HoldShipmentButton {...props} />
          );
        }

        if (isEntryEditable && props?.serviceType === 'IMPORT') {
          listOfButtons.push(<RefreshTariffButton {...props} />)
        }

        if (!reviewedSuccessfully) {
          listOfButtons.push(
            <>
              <Button
                id='xml-review'
                size="mini"
                key="XMLREVIEW"
                disabled={false}
                className="sv todo-button primaryBtn"
                onClick={(e) => {
                  window.open(`broker-panel/xml-review/${props.shipId}/${formType}`, '_blank');
                }}
              >
                {`XML REVIEW`}
              </Button>
              <ReviewEntryButton
                setReviewSuccessfully={setReviewedSuccess}
                currentEntryState={EntryState}
                alertMessages={alertMessageOnReview()}
                {...props}
                formType={formType}
              />
            </>
          );
        }
      }
      if (configuration['GB']["SKIP_PDF"] && reviewedSuccessfully) {
        listOfButtons.push(
          <PreviewPDFButton
            {...props}
            formType={formType}
          />
        );
      }

      if (isEntryFileReady && reviewedSuccessfully) {
        listOfButtons.push(
          <FileEntryButton
            {...props}
            formType={formType}
          />
        );
      }

      if (((isEntryFiled && isCustomNone) || (isEntryAccepted && ESCustomState === "STATE_DMSRCV")) || (isEntryRejected || isEntryAmendRejected || isEntryAmendFailed || isEntryAccepted || isEntryAmendAccepted || isEntryCleared)
        && ESCustomState !== "STATE_DMSEOG") {
        let label = (isEntryAccepted || isEntryAmendAccepted || isEntryAmendRejected || isEntryAmendFailed || isEntryCleared) ? "AMEND" : "UPDATE"
        label = ((isEntryFiled && isCustomNone) || (isEntryAccepted && ESCustomState === "STATE_DMSRCV")) ? 'RESET' : label;

        listOfButtons.push(
          <UpdateEntry
            {...props}
            label={label}
            EntryState={EntryState}
          />
        );

        if (isEntryAccepted && ESCustomState === "STATE_DMSRCV") {
          listOfButtons.push(
            <UpdateEntry
              {...props}
              label={'AMEND'}
              EntryState={EntryState}
            />
          );
        }
      }
      if (['STATE_DMSREJ', 'STATE_DMSRCV', 'STATE_DMSTAX'].includes(ESCustomState)) {
        listOfButtons.push(
          <div id="sendArrival-notice-button"></div>
        );
      }
      if (isEntryAmendInProcess || isEntryAmendFileReady) {
        listOfButtons.push(
          <UpdateEntry
            {...props}
            label='CANCEL AMEND'
            EntryState={EntryState}
          />
        );
      }
      if ((isCancelledFailed || isEntryAccepted || isEntryCleared) && (props?.serviceType === 'IMPORT' ? ESCustomState !== "STATE_DMSCLE" : true)) {
        listOfButtons.push(
          <Button
            size="mini"
            id="cancelShipment"
            key="CANCEL_ES"
            disabled={false}
            className="sv todo-button primaryBtn"
            onClick={() => {
              setCdsLabel("Cancel")
              setCdsFormType("CDS_CANCEL")
              setShowModal(true)
            }}
          >
            {"CANCEL"}
          </Button>)
      }
      if (isCancelAccepted) {
        listOfButtons.push(
          <div style={{ fontSize: '13px', color: 'crimson' }}>
            <strong>Note: </strong>No Action can be performed after Cancellation
            Accepted.
          </div>)
      }
      if (mrn) {
        listOfButtons.push(<Button
          size="mini"
          id="declarationStatus"
          key="declarationStatus"
          disabled={false}
          className="sv todo-button primaryBtn"
          onClick={decStatusAction}
        >
          {"DECLARATION STATUS"}
        </Button>)
      }
      return listOfButtons
    }
    return listOfButtons
  }




  let workflowButtons = buildButtons() || []

  return (
    <div className="ace header-container dv-todo-isfheader">
      <ExpandCollapseButton {...props} />
      <>
        {
          showModal &&
          <CDSModal
            key={`cancelship-${cdsLabel}`}
            shipmentId={window.shipmentId}
            fileWithGateway={true}
            showModal={showModal}
            label={cdsLabel}
            setShowModal={setShowModal}
            formType={cdsFormType}
            cancelReason={""}
            searchByID={props.searchByID}
          />
        }
        {
          window.typeOfUser !== "BROKER_KN_ADMIN" && workflowButtons.map((buttonItem, idx) => {
            return <React.Fragment key={idx + "-workflow-btn"}>{buttonItem}</React.Fragment>
          })
        }
      </>

    </div>
  );
}

export default CDSButtonMapper;